import { PartnerCollection } from '@sly/core/types';
import dayjs from 'dayjs';

interface GetSource {
  isD2C: boolean;
  partnerCollection?: PartnerCollection;
  isClaimed: boolean;
  auditDate?: string;
  seoLastUpdatedAt: string;
  name: string;
  dohLicenseNumber?: string;
}

export const getSource = ({
  isD2C,
  partnerCollection,
  isClaimed,
  seoLastUpdatedAt,
  auditDate,
  name,
  dohLicenseNumber
}: GetSource) => {
  const text =
    'The content on this page has been reviewed for accuracy by the community manager.';

  if (partnerCollection?.url && isD2C) {
    return {
      name: partnerCollection.name,
      link: partnerCollection.url,
      text,
      linkText: `Learn more about ${partnerCollection.name}`
    };
  }
  if (isClaimed) {
    return {
      name,
      text
    };
  }
  if (
    auditDate ||
    (seoLastUpdatedAt && dayjs(seoLastUpdatedAt) > dayjs().subtract(6, 'month'))
  ) {
    return {
      name: 'Sharon. S',
      text: "Sharon S. is the Director of Community Data at Seniorly, overseeing the management of detailed information for over 66,000 senior living communities. With a Master's in Library Science and deep expertise in taxonomy, Sharon ensures the accuracy and accessibility of our data, empowering millions of users to make informed decisions each year.",
      link: '/resource-center/author/sharon+s',
      linkText: 'Learn more'
    };
  }
  if (dohLicenseNumber) {
    return {
      name: 'cms.gov',
      link: 'https://www.cms.gov',
      text: "CMS is the federal agency that provides health coverage to more than 160 million through Medicare, Medicaid, the Children's Health Insurance Program, and the Health Insurance Marketplace. CMS works in partnership with the entire health care community to improve quality, equity and outcomes in the health care system.",
      linkText: 'Learn more'
    };
  }

  return {};
};
